/**
 * @param {number} [range]
 * @param {Date} [start]
 * @param {Date} [end]
 * @returns {Date[]}
 */
export default function dateRange(
	range = 8,
	start = new Date(`2024-03-01`),
	end = new Date()
) {
	const diffTime = Math.abs(Number(end) - Number(start));
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	const step = Math.floor(diffDays / range);
	const dates = [];

	// eslint-disable-next-line no-plusplus
	for (let index = 0; index < range; index++) {
		const newDate = new Date(start);
		newDate.setDate(start.getDate() + (step * index)); // prettier-ignore
		dates.push(newDate);
	}

	return dates.reverse();
}
